import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {DeletedLearningPlan, GetLearningPlanCombined, GetPlanSchedule, GetSearchLearningPlan} from "./thunk";
import {IEntityWithIDTranslations, ITranslation} from "../../../../types";
import {ICoursePlan,IInitialStateLearningPlan,ILearningPlanInformationPayload} from "./types";



const initialState: IInitialStateLearningPlan = {
    learningPlanSchedule: [],
    learningPlanInformation: [],
    learningType: [],
    filterLearningType: [],
    filterCourseFormat: [],
    courseFormat: [],
    planSettings:{},
    isLoadingLearningPlan: false,
    isLoadingLearningInformation: false,
    planPeriod: "Year",
    planMonthIndex: null,
    learningCurrentId: 0,
    educationSectorID:0,
    learningCourseTerm: 0,
    learningPlanTerm:[],
    learningPlanDeleted:[],
    isHidePlanSubject:false,
    educationalStatistics:[],
    isViewRestoreLearningPlan:false,
    isChangePlanSymbols:false,
    currentLearningPlan:0

}

const learningPlanSlice = createSlice({
    name: "learningPlan",
    initialState,
    reducers: {
        setLearningPlanSchedule(state, action: PayloadAction<ICoursePlan[]>) {

            const data = action.payload;


            state.educationSectorID = Array.isArray(data) && data.length > 0 ? data[0].education_sector_id : 0;

            state.learningPlanSchedule = data;
            const courses = data.map((item) => item.course)
            state.learningCourseTerm = courses.length ;

        },
        setIsLearningPlanInformation: (state, action:PayloadAction<{data:ILearningPlanInformationPayload[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload
            const filterDataByDefaultLanguage = (data: ILearningPlanInformationPayload[]) => {
                return data.map((item) => ({
                    ...item,
                    educational_degree: item.educational_degree.filter(
                        (degree:ITranslation) => degree.slug === defaultLanguage
                    ),
                    academic_year: item.academic_year.filter(
                        (year) => year.slug === defaultLanguage
                    ),
                    faculty: item.faculty.filter(
                        (fac:ITranslation) => fac.slug === defaultLanguage
                    ),
                    learning_format: item.learning_format.filter(
                        (format:ITranslation) => format.slug === defaultLanguage
                    ),

                    profession: item.profession.filter(
                        (prof:ITranslation) => prof.slug === defaultLanguage
                    ),
                    educational_program:item.educational_program.filter(
                        (prof:ITranslation) => prof.slug === defaultLanguage
                    ),
                    course_format: item.course_format.filter(
                        (course :ITranslation) => course.slug === defaultLanguage
                    ),
                    learning_type: item.learning_type.filter(
                        (type:ITranslation) => type.slug === defaultLanguage
                    ),
                }));
            };

            state.learningPlanInformation = filterDataByDefaultLanguage(data);
        },
        setLearningPlanDeleted: (state, action:PayloadAction<{data:ILearningPlanInformationPayload[],defaultLanguage:string}>) => {

            const {data,defaultLanguage} = action.payload

            const filterDataByDefaultLanguage = (data: ILearningPlanInformationPayload[]) => {

                return data.map((item) => ({
                    ...item,
                    educational_degree: item.educational_degree.filter(
                        (degree:ITranslation) => degree.slug === defaultLanguage
                    ),
                    academic_year: item.academic_year.filter(
                        (year) => year.slug === defaultLanguage
                    ),
                    faculty: item.faculty.filter(
                        (fac:ITranslation) => fac.slug === defaultLanguage
                    ),
                    learning_format: item.learning_format.filter(
                        (format:ITranslation) => format.slug === defaultLanguage
                    ),

                    profession: item.profession.filter(
                        (prof:ITranslation) => prof.slug === defaultLanguage
                    ),
                    course_format: item.course_format.filter(
                        (course :ITranslation) => course.slug === defaultLanguage
                    ),
                    learning_type: item.learning_type.filter(
                        (type:ITranslation) => type.slug === defaultLanguage
                    ),
                }));
            };

            state.learningPlanDeleted = filterDataByDefaultLanguage(data);
        },


        setIsLearningType: (state, action:PayloadAction<{data:IEntityWithIDTranslations[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload

            state.learningType = data

            state.filterLearningType = data.flatMap((elem) => {
                return elem.translations
                    .filter((item) => item.slug === defaultLanguage)
                    .map((translation) => {

                        return {
                            id: elem.id,
                            name: translation.name || ""
                        };
                    });
            });
        },

        setCourseFormat: (state, action:PayloadAction<{data:IEntityWithIDTranslations[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload

            state.courseFormat = data
            state.filterCourseFormat = data.flatMap((elem) => {


                return elem.translations
                    .filter((item) => item.slug === defaultLanguage)
                    .map((translation) => {

                        return {
                            id: elem.id,
                            name: translation.name || ""
                        };
                    });
            });
        },
        setIsPlanPeriod: (state, action) => {

            state.planPeriod = action.payload;
            state.planMonthIndex = 9
        },
        setIsChangePlanSymbols:(state,action:PayloadAction<boolean>)=>{
            state.isChangePlanSymbols = action.payload;
        },
        setPlanMonthIndex(state, action) {

            state.planMonthIndex = action.payload;
        },
        setIsLearningCurrentId: (state, action) => {
            state.learningCurrentId = action.payload;
        },

        setIsHidePlanSubject:(state) => {
            state.isHidePlanSubject =!state.isHidePlanSubject;
        },
        setEducationalStatistics:(state, action) => {
            state.educationalStatistics = action.payload;
        },

        setLearningPlanTerm:(state,action)=>{
            state.learningPlanTerm = action.payload
        },
        setDefaultPeriod:(state,action)=>{
            state.planPeriod = action.payload
        },
        setPlanSettings:(state,action)=>{

            state.planSettings = action.payload
        },
        clearLearningPlanState:(state)=>{
            state.learningCourseTerm = 0

        },
        setIsViewRestoreLearningPlan:(state) => {
            state.isViewRestoreLearningPlan = !state.isViewRestoreLearningPlan
        },
        setCurrentLearningPlan:(state,action:PayloadAction<{id:number}>)=>{
            const {id} = action.payload
            state.currentLearningPlan =id

        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(GetLearningPlanCombined.pending, (state) => {
                state.isLoadingLearningInformation = true;
            })
            .addCase(
                GetLearningPlanCombined.fulfilled,
                (state) => {
                    state.isLoadingLearningInformation = false;

                }
            )
            .addCase(GetLearningPlanCombined.rejected, (state) => {
                state.isLoadingLearningInformation = false;
            })
            .addCase(DeletedLearningPlan.pending, (state) => {
                state.isLoadingLearningInformation = true;
            })
            .addCase(
                DeletedLearningPlan.fulfilled,
                (state) => {
                    state.isLoadingLearningInformation = false;

                }
            )
            .addCase(DeletedLearningPlan.rejected, (state) => {
                state.isLoadingLearningInformation = false;
            })
            .addCase(GetPlanSchedule.pending, (state) => {
                state.isLoadingLearningPlan = true;
            })
            .addCase(
                GetPlanSchedule.fulfilled,
                (state) => {
                    state.isLoadingLearningPlan = false;

                }
            )
            .addCase(GetPlanSchedule.rejected, (state) => {
                state.isLoadingLearningPlan = false;
            })
            .addCase(GetSearchLearningPlan.pending, (state) => {
                state.isLoadingLearningInformation = true;
            })
            .addCase(
                GetSearchLearningPlan.fulfilled,
                (state) => {
                    state.isLoadingLearningInformation = false;

                }
            )
            .addCase(GetSearchLearningPlan.rejected, (state) => {
                state.isLoadingLearningInformation = false;
            })
    }

})
export const {
    setLearningPlanSchedule,
    setIsLearningType,
    setCourseFormat,
    setIsLearningPlanInformation,
    setIsPlanPeriod,
    setPlanMonthIndex,
    setIsLearningCurrentId,
    setIsHidePlanSubject,
    setEducationalStatistics,
    setLearningPlanTerm,
    setDefaultPeriod,
    setPlanSettings,
    setLearningPlanDeleted,
    clearLearningPlanState,
    setIsViewRestoreLearningPlan,
    setIsChangePlanSymbols,
    setCurrentLearningPlan
} = learningPlanSlice.actions
export default learningPlanSlice;